

























































import { Component, Vue } from 'vue-property-decorator'
@Component
export default class UserPrivacy extends Vue {
   statusHeight:string  = 120 + 'rpx'
}
